<template>
	<header class="sub-header">
		<div class="container">
			<div class="row">
				<div class="col-md-7 mx-auto">
					<h1>Invest Now With Reiturn</h1>
					<p>Already have an account? <a :href="investmentPortalAuthEndPoint">Login</a></p>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import {PORTAL_URL} from "@/main";

export default {
    name: 'SubHeader',
	computed: {
        investmentPortalAuthEndPoint() {
            return PORTAL_URL + "/login";
		}
	},
}
</script>

<style lang="scss">
.sub-header {
	background: #f1f6f8;
	padding: 5rem 0 3.5rem 0;

	@media (max-width: 767.99px) {
		padding: 1rem 0 0 0;
		background: #fff;
	}

	h1 {
		font-weight: bold;
		color: #16193a;
		font-size: 3rem;
		margin: 0 0 1rem 0;

		@media (max-width: 767px) {
			font-size: 2rem;
		}
	}

	p {
		color: #16193A;
		font-size: 1.25rem;
		margin: 0;

		@media (max-width: 767px) {
			font-size: 1rem;
		}

		a {
			color: #F37021;
			font-weight: bold;
			text-decoration: none;
			font-size: 1.15rem;
		}
	}
}
</style>